import React, { Component } from 'react';
import {
    MyPATMathField,
    MyPATDialog,
    MyPATTextArea
} from "../../../.././common";
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
    Typography, createStyles, WithStyles, Button, Tabs, Grid, Tab, DialogContent, IconButton
} from '@material-ui/core';
import { showMsg } from '../../../../course/actions/loaderAlert';

import {
    NavigateBeforeOutlined as BackIcon,
} from "@material-ui/icons";
import WithContent from "../../../containers/WithContent";
import ContentFormData from '../../../types/ContentFormData';
import { notesActions } from '../../../reducers/notesReducers';
import ContentFormDataError from '../../../types/ContentFormDataError';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import CheckBox from '../wrapperComponent/wrapperCheckBox';
import MyPATBaseSection, { SectionFocusedContext, SectionFocusedContextValue } from '../../../../common/MyPATBaseSection';
// import { createNotesQuestionSchema } from '../validations/validation';

const updater = (action: string, value: number) => {
    switch (action) {
        case "INCREMENT":
            return value + 1;
        case "DECREMENT":
            return value - 1;
        default:
            return null;
    }
};

const styles = (theme: Theme) => createStyles({
    root: {
        flex: 'grow'
    },
    tabsAlign: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    textAlignRight: {
        textAlign: "right"
    },
    addButtonAlign: {
        display: 'flex',
        alignContent: 'center',
        flexDirection: 'row-reverse'
    },
    chooseFromLibraryButton: {
        display: 'flex',
        alignContent: 'center',
        justifyContent: 'space-around'

    },
    mb1x: {
        marginBottom: theme.spacing.unit
    },
    // oRText: {
    //     display: 'flex',
    //     marginBottom: theme.spacing.unit,
    //     justifyContent: 'space-around'

    // },
    questionParagraph: {
        maxWidth: 380,
        '& >p': {
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            margin: '0',
        }
    },
    questionInfo: {
        border: `1px solid ${theme.palette.grey[300]}`,
        "& > div": {
            padding: `0 ${theme.spacing.unit}px`
        },
        "& > div:first-child": {
            paddingTop: theme.spacing.unit,
            paddingBottom: theme.spacing.unit,
            borderRight: `1px solid ${theme.palette.grey[300]}`
        }
    },
    optionContent: {
        "& .btn-delete": {
            visibility: "visible"
        },
        '& p>img': {
            maxWidth: '100%'
        }
    },
    questionActionBtn: {
        padding: theme.spacing.unit,
        minWidth: "auto",
        backgroundColor: theme.palette.grey[200],
        border: `1px solid ${theme.palette.grey[300]}`,
        color: theme.palette.text.secondary,
        borderRadius: 0
    },
    buttonAlign: {
        display: 'flex',
        alignContent: 'center',
    },

    notesBlockTitle: {
        fontSize: 20,
        fontWeight: 400,
        paddingTop: 20,
    },
    addQuestionTitle: {
        fontSize: 16,
        fontWeight: 400,
        fontFamily: 'Nunito',
    },
    tabsNotes: {
        fontSize: 16,
        fontWeight: 400,
        padding: 0,
        marginBottom: '15px',
    },
    tabsContainer: {
        // border: 'solid 1px #E1E1E1',
        margin: '0 0 10px 0',
        // padding: '20px',
        borderRadius: '5px',
        "position": "relative",
        '& label': {
            fontSize: 20,
            lineHeight: "22px",
            color: "#333333",
        },
    },
    tabsContainer2: {
        border: 'solid 1px #E1E1E1',
        margin: '5px 0 10px 0',
        padding: '20px',
        borderRadius: '5px',
        "position": "relative",
        '& label': {
            fontSize: 20,
            lineHeight: "22px",
            color: "#333333",
        },
    },
    searchNotesinput: {
        fontSize: 14,
        fontWeight: 400,
        padding: 0,
        fontStyle: "italic",
        '& input': {
            paddingLeft: "40px",
        },
    },
    OrDivider: {
        margin: "50px 0 25px 0",
        display: "block",
        position: "relative",
        textAlign: "center",
        height: "50px",
        zIndex: 0,
    },
    orText: {
        background: "#E0E6E7",
        height: "40px",
        width: "40px",
        borderRadius: "100%",
        fontStyle: "italic",
        fontSize: 14,
        color: "#989898",
        display: "inline-block",
        paddingTop: "8px",
        "position": "absolute",
        "top": "-20px",
        left:'47%',
    },
    dividerBar: {
        "position": "absolute",
        "left": 0,
        "top": "15px",
        width: "100%",
        "content": " ",
        height: "1px",
        background: "#E0E6E7",
        "z-index": "1",
    },
    textAlignCenter: {
        textAlign: "center",
    },

    addPageMore: {
        background: '#FFF !important',
        color: '#1D7DEA !important',
        width: '100',
        marginRight: 6,
        border: '1px solid #1D7DEA',
        boxSizing: 'border-box',
        borderRadius: 4,
        fontWeight: 600,
        fontSize: '0.875rem',
    },
    seachQuestionText: {
        fontSize: 16,
        fontWeight: 400,
        padding: 0,
    },
    containerBorder: {

    },
    imgSearch: {
        "position": "absolute",
        "left": "30px",
        "top": "54px",
        "z-index": "1",
    },
    ". MuiTab-root-355": {
        fontSize: "1.25rem !important",
    },
    selectedQues: {
        paddingRight: '20px',
    },
    dialogContent: {
        padding: 0,
        maxHeight: '100%',
        marginTop: 74
    },
    mandatory: {
        color: 'red',
    },
    ".MuiPrivateTabIndicator-colorPrimary-343": {
        backgroundColor: 'none !important',
    },
    ".MuiPrivateTabIndicator-root-342": {
        display: "none !important",
    },
    subHeadingContainer : {
        paddingTop: "20px",
        "& > div:last-child > div": {
            marginTop:"5px"
        }
    },
    optionalText: {
        fontSize: '20px',
        color: '#999999',
    }
});

interface StudyNotesCreateProps extends WithStyles<typeof styles> {
    history: any,
    actionType: any,
    notesData: any,
    handleNotesData: any,
    pageSetForNotes: any,
    setConceptAndChapters: any,
    addTags: any,
    formData: ContentFormData,
    formDataError: ContentFormDataError,
    handleFormChange: Function,
    type: any,
    showMsg: any,
    subType: any,
    prevSubTypesState: any,
    setPageInContent: any,
    removeStyleInContent: any,
    tagsList: any,
    pageKey: any,
    handlePageState: any,
    errorMessage: any,
}
interface StudyNotesCreateState {
    title: string,
    subHeading: string,
    pageState: any,
    componentAddCounter: any,
    componenetStoreArray: any,
    isDisabled: boolean,
    touched: any,
    isAddInstruction: boolean,
    isCustomDescription: boolean,
    errorMessage: any,
    pageSetForNotes: any,
    deletePopUpDialogforPage: any,
    statusTypes: any,
    deletePopUpDialog: any,
    tags: any,
    isOtherOptionsOpen: boolean;
    isFixedAttempts: boolean;
    pageArray: any,
    courses: any;
    loadingTemplates: boolean;
    templates: any;
    languages: any;
    viewDetailId: string;
    selectedTemplateId: string;
    selectedSectionId: string;
    courseName: string;
    selectQuestionDialogOpen: boolean,
    setConceptAndPages: any,
    preSelectedFilterContent: any,
    selectedQuestionCount: any,
    isCollaspableAllowed: any,
    mathEditor: any,
    searchId: any,
    linkState: any,
    inSectionContent: any,
    selectQuestionDialogData: {
        sectionId: string;
        subSectionId: string;
        quesCodeAllowed: number;
        noOfQuestions: number;
        replaceIndex: number;
        replaceIndexJ: number;
        content_Id: string;
        addedQuestions: any;
    };
    selectedTempQuestions: any;
    chooseLibraryKey: any,
    selectedTrackedQuestionIds: any;
    data: any;
}
class StudyNotesCreate extends Component<StudyNotesCreateProps, StudyNotesCreateState> {
    constructor(props: StudyNotesCreateProps) {
        super(props);
        // unused state should be remove further
        this.state = {
            title: this.props.notesData.title,
            subHeading: this.props.notesData.subHeading,
            pageState: { ...this.props.notesData.pageState },
            pageSetForNotes: {},
            componentAddCounter: Object.keys(this.props.notesData.pageState).length - 1,
            componenetStoreArray: [1],
            inSectionContent: [...this.props.prevSubTypesState],
            isDisabled: false,
            isAddInstruction: true,
            isCustomDescription: true,
            deletePopUpDialogforPage: false,
            touched: {},
            setConceptAndPages: [],
            tags: [],
            searchId: '',
            errorMessage: {},
            statusTypes: {
                page1: this.props.prevSubTypesState[0].subType[0]
            },
            pageArray: [],
            linkState: '',
            loadingTemplates: false,
            isOtherOptionsOpen: false,
            isFixedAttempts: false,
            deletePopUpDialog: false,
            selectedQuestionCount: 0,
            courses: [],
            templates: [],
            languages: [],
            viewDetailId: "",
            selectedTemplateId: "",
            selectedSectionId: "",
            courseName: "",
            mathEditor: null,
            chooseLibraryKey: '',
            preSelectedFilterContent: {},
            selectQuestionDialogOpen: false,
            selectQuestionDialogData: {
                sectionId: "",
                subSectionId: "",
                quesCodeAllowed: -1,
                noOfQuestions: 0,
                replaceIndex: -1,
                replaceIndexJ: -1,
                content_Id: "",
                addedQuestions: []
            },
            selectedTempQuestions: [],
            selectedTrackedQuestionIds: {},
            data: [],
            isCollaspableAllowed: {},
        }
    }

    componentDidMount(): void {
        const {pageKey, notesData = {}} = this.props;
        const { pageState = {} } = notesData;
        const subHeading = pageState[pageKey]['theory']['subHeading'] || '';
        !subHeading && this.props.handlePageState(pageKey, 'subHeading', 'theory').call(this);
    }

    handleCustomAndInstructionValidation = (key: any = '', field: any = '') => {
        const { errorMessage = {} } = this.state;
        const { notesData: { pageState = {} } = {} } = this.props;
        if (!typeof (pageState[key][field]) === undefined) {
            this.setState({
                errorMessage: {
                    ...errorMessage,
                    [field]: 'it Should not be empty'
                }
            })
        }
        else {
            this.setState({
                errorMessage: {
                    ...errorMessage,
                    [field]: ''
                }
            })
        }
    }

    getPageNumber = (key: any): any => {
        const extractNumber = key.replace(/^\D+/g, '');
        return extractNumber;
    }

    isError = (fields: any) => {
        const { errorMessage } = this.state;
        if (errorMessage[fields]) {
            return true;
        }
        return false;
    }

    handleContentSelect = (selectedQuestions: any) => {
        const firstSelectedQuestion = selectedQuestions[0];
        if (selectedQuestions.length > 0) {
            this.setState({
                selectedQuestionCount: 1,
            });
        } else {
            this.setState({
                selectedQuestionCount: 0,
            });
        }
        this.setState({ selectedTempQuestions: firstSelectedQuestion });
    }

    handleContentSelectAll = (selectedQuestions: any) => {
        this.handleTrackSelectedQuestionIds(selectedQuestions)
        this.setState({ selectedTempQuestions: selectedQuestions });
    }
    handleCheckContentExist = (content_Id: string) => {
        const { selectedTrackedQuestionIds, selectQuestionDialogData } = this.state
        const { subSectionId: selectedSubSectionId, content_Id: selectedContentId, addedQuestions, quesCodeAllowed: selectedQuestCode, replaceIndex } = selectQuestionDialogData
        const addedContent_Ids: any = new Set(addedQuestions.map((content: any) => content.content_Id))
        addedContent_Ids.delete(selectedContentId)
        const key = content_Id
        let isContentExist = false;
        if (selectedTrackedQuestionIds.hasOwnProperty(key)) {
            const quesCodeAllowed = selectedTrackedQuestionIds[key].quesCodeAllowed
            const subSectionId = selectedTrackedQuestionIds[key].subSectionId
            if (replaceIndex !== -1) {
                if (content_Id !== selectedContentId && addedContent_Ids.has(content_Id)) {
                    isContentExist = true
                }
            } else {
                if (selectedQuestCode == quesCodeAllowed) {
                    if (selectedSubSectionId !== subSectionId) {
                        isContentExist = true
                    }
                }
            }
        }
        return isContentExist
    }

    handleBackToTestpaperClick = (evt: any) => this.setState({ selectQuestionDialogOpen: false });

    handleTrackSelectedQuestionIds(selectedQuestions: any) {
        const { selectedTrackedQuestionIds, selectQuestionDialogData } = this.state;
        const { quesCodeAllowed, subSectionId } = selectQuestionDialogData
        selectedQuestions.forEach((question: any) => {
            const key = question.content_Id
            if (!selectedTrackedQuestionIds.hasOwnProperty(key)) {
                selectedTrackedQuestionIds[key] = {
                    quesCodeAllowed,
                    subSectionId,
                    content_Id: question.content_Id
                }
            }
        });
        this.setState({ selectedTrackedQuestionIds });
    }

    handleAddContentClick = () => {
        let { selectedTempQuestions, chooseLibraryKey, data } = this.state;
        const { pageState = {} } = this.props.notesData;
        let copyPageState = { ...pageState };
        copyPageState = {
            ...copyPageState,
            [chooseLibraryKey]: {
                ...copyPageState[chooseLibraryKey],
                searchId: selectedTempQuestions.contentId,
                title: selectedTempQuestions.title,
                content_Id: selectedTempQuestions.content_Id,
            }
        }
        this.props.handleNotesData({ pageState: { ...copyPageState } });
        this.setState({
            data: data,
            selectQuestionDialogOpen: false,
            selectedTempQuestions: [],
        });
    };

    handleCloseDialog = () => {
        this.setState({
            deletePopUpDialog: false,
        })
    }

    setMathInstance = (mathEditor: any) => {
        this.setState({ mathEditor })
    }

    withContent = () => {
        const {
            selectedQuestionCount
        } = this.state;

        let { selectQuestionDialogOpen } = this.state;

        const otherDialogProps = {
            fullScreen: true
        };
        let selectedQuestionsCount = 0;
        let { selectedTempQuestions, selectedTrackedQuestionIds, preSelectedFilterContent } = this.state;
        return (
            <MyPATDialog
                dialogOpen={selectQuestionDialogOpen}
                otherDialogProps={otherDialogProps}
                target="_blank"
                customDialogTitle={
                    <>
                        <Grid container justify="space-between" alignItems="center">
                            <Grid item xs="auto">
                                <Typography
                                    color="textPrimary"
                                    variant="body1"
                                    style={{ cursor: 'pointer' }}
                                    onClick={this.handleBackToTestpaperClick.bind(this)}
                                >
                                    <BackIcon />
                                    <strong>Back to Study Material Notes</strong>
                                </Typography>
                            </Grid>
                            <Grid item xs />
                            <Grid item xs="auto">
                                <Typography variant="caption" inline>
                                    <b style={{ marginRight: '20px', fontSize: 16, }}>{selectedQuestionCount}/ 1 Selected</b>
                                </Typography>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    disabled={selectedQuestionCount < 1}
                                    onClick={() => this.handleAddContentClick()}
                                >
                                    Add Content
                  </Button>
                            </Grid>
                        </Grid>
                    </>
                }
            >
                <WithContent
                    isInPopUp={true}
                    selectedQuestions={selectedTempQuestions}
                    selectedTrackedQuestionIds={selectedTrackedQuestionIds}
                    onContentSelect={this.handleContentSelect.bind(this)}
                    onContentSelectAll={this.handleContentSelectAll.bind(this)}
                    onCheckContentExist={this.handleCheckContentExist.bind(this)}
                    selectedFilterContent={preSelectedFilterContent}
                    fromTestPaper={true}
                    contentMenuRequired={false}
                />
            </MyPATDialog>
        )
    }

    selectText = (text: any) => {
        const { notesData: { pageState = {} } = {} } = this.props;
        if (text && text !== this.state.linkState) {

            let str = pageState['page1']['customDescription'];
            let indexOf = str.indexOf(text);
            let html = `<a href="#" title="PopoverHeader" data-trigger="anchor" data-toggle="popover" data-placement="top" data-content="<h1>check</h1>">${text}</a>`;
            let newString = str.replace(text, html);
            this.props.handleNotesData({
                pageState: {
                    ...pageState,
                    ['page1']: {
                        ...pageState['page1'],
                        customDescription: newString,
                    }
                }
            });
            this.setState({
                linkState: text,
            })
        }
    }

    addPageComponent = (pageNameKey: any): any => {
        const { pageState } = this.props.notesData;
        const { classes } = this.props;
        // const pageName = `Page ${count + 1}`;
        // const pageNameKey = `page${count + 1}`;
        const subHeading = pageState[pageNameKey]['theory']['subHeading'] || '';
        return (
            <SectionFocusedContext.Consumer>
                {({ setSectionFocus }: SectionFocusedContextValue) => (
                <MyPATBaseSection sectionId={`createNotes-${pageNameKey}`} applyFocusedBorder={false} onFocusChange={setSectionFocus}>
                    <div className={classes.tabsAlign} style={{ paddingTop: '20px', }}>
                    </div>
                    <div>
                        {/* need to add css in this component*/}
                        <div className={classes.tabsContainer}>
                            <div className={classes.subHeadingContainer}>
                                <div>
                                    <b className={classes.addQuestionTitle}>Sub Heading</b>&nbsp;<span className={classes.optionalText}>(Optional)</span>
                                </div>
                                <MyPATTextArea
                                    name="subHeading" placeholder="Enter sub heading here" fullWidthControl
                                    onChange={this.props.handlePageState(pageNameKey, 'subHeading', 'theory')} value={subHeading}
                                />
                            </div>
                            <div>
                                <Typography
                                    variant="h6" style={{ fontSize: 16, fontWeight: 'normal', }}
                                >
                                </Typography>
                                <MyPATMathField
                                    variant='textarea'
                                    editorProps={{
                                        externalToolbarId: 'box',
                                        name: `theoryDescription`,
                                        handleChange: this.props.handlePageState(pageNameKey, 'theoryDescription', 'theory'),
                                        select: this.selectText,
                                        setInstance: this.setMathInstance,
                                        editorId: pageNameKey,
                                        value: pageState[pageNameKey]['theory']['theoryDescription'] || ""
                                    }}
                                />
                                {this.props.errorMessage && this.props.errorMessage[pageNameKey] && this.props.errorMessage[pageNameKey]['theory'] ?
                                    (<p style={{ color: 'red' }}>{this.props.errorMessage[pageNameKey]['theory'].theoryDescription}</p>) : ''
                                }
                            </div>
                        </div>
                    </div>
                </MyPATBaseSection>
                )}
            </SectionFocusedContext.Consumer>
        )
    }

    render = () => {
        const { errorMessage } = this.state;
        const { classes, type, notesData: { pageState = {}, title = '', subjects = [], tags = [] } = {}, pageKey } = this.props;
        return (
            <>
                {/* <div>
                    {errorMessage['title']? errorMessage['title']: ''}
                    </div> */}
                {
                    this.addPageComponent(pageKey)
                }
                {
                    this.withContent()
                }
            </>
        );
    }
};

const mapStateToProps = (state: any) => {
    return {
        prevSubTypesState: _.get(state, 'studyNotedReducers', []),
        tagsList: _.get(state, 'mylibraryData.contentTags.list', [])
    }
};

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
    setPageInContent: notesActions.addSubTypes,
    removeStyleInContent: notesActions.removeSubTypes,
    showMsg: showMsg,
    setConceptAndChapters: notesActions.addConceptAndChapter,
    setTags: notesActions.addExtraTags
}, dispatch);
// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(StudyNotesCreate));